import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/Button';
import { Card } from '@/components/Cards';
import { Icon } from '@/components/Icons';
import { ButtonVariant, IconType, Size } from '@/types/components';

interface Props {
  firstName: string;
  lastName: string;
  className: string;
  schoolName: string;
  onStudentAdd?: () => void;
  onStudentRemove?: () => void;
}

export const StudentJoinCard: React.FC<Props> = ({
  firstName,
  lastName,
  className,
  schoolName,
  onStudentAdd,
  onStudentRemove,
}) => {
  const { t } = useTranslation();

  return (
    <Card>
      <div className="flex flex-col gap-1">
        <p className="text-callout-16 text-foreground">
          {firstName} {lastName}
        </p>
        <p className="text-body-14 text-foreground">
          {className}, {schoolName}
        </p>
      </div>
      <div className="flex gap-3">
        <Button
          variant={ButtonVariant.Secondary}
          size={Size.Small}
          className="flex-1"
          onClick={onStudentRemove}
        >
          {t('global.decline')}
        </Button>
        <Button
          variant={ButtonVariant.Primary}
          size={Size.Small}
          className="flex-1"
          onClick={onStudentAdd}
        >
          <Icon icon={IconType.PlusSign} />
          {t('global.add')}
        </Button>
      </div>
    </Card>
  );
};
